module.exports = __webpack_public_path__ + "img/digit-4.fc5ff341.png";